<template>
    <v-main class="lyt-container pt-3 justify-center custom-main">
        <v-container>
            <v-row class="d-flex justify-center white--text">
                <h1><i class="fas fa-users"></i> Padrón Activo</h1>
            </v-row>
            <v-row class="d-flex justify-center mt-4 table-admins">
                <v-data-table
                    :headers="headers"
                    :items="padron"
                    :loading="isLoading"
                    :options.sync="options"
                    :search="search"
                    :server-items-length="totalRows"
                    class="datatable-admins"
                >
                    <template v-slot:top>
                        <v-select
                            v-model="electionIdSelected"
                            :item-text="textItemElection"
                            :items="elecciones"
                            :loading="isLoading"
                            class="mx-4"
                            item-value="id"
                            label="Selecciona elección"
                            @change="onChangeElection"
                        >
                        </v-select>
                        <v-text-field
                            v-model="search"
                            class="mx-4"
                            label="Buscar"
                            type="text"
                        >
                            <template v-slot:append-outer>
                                <v-btn
                                    :disabled="isLoading"
                                    color="blue"
                                    @click="loadPadron"
                                >
                                    <i
                                        :class="{ isLoading: 'fa-spin' }"
                                        class="white--text fa fa-sync"
                                    ></i>
                                </v-btn>
                            </template>
                        </v-text-field>
                    </template>
                </v-data-table>
            </v-row>
        </v-container>
    </v-main>
</template>
<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';
import { mapGetters } from 'vuex';
import 'moment/locale/es-mx';
import debouncer from '@/helpers/debouncer';

export default {
    computed: {
        ...mapGetters({
            elecciones: 'elecciones/elecciones',
        }),
    },
    components: {
        ScaleLoader,
    },
    watch: {
        options: {
            handler() {
                this.loadPadron();
            },
            deep: true,
        },
        search: {
            immediate: false,
            handler: debouncer(function() {
                this.loadPadron();
            }, 800),
        },
    },
    data() {
        return {
            headers: [
                {
                    text: 'Código',
                    value: 'codigo',
                },
                {
                    text: 'Nombre',
                    value: 'nombre',
                },
                {
                    text: 'Apellido',
                    value: 'apellido',
                },
                {
                    text: 'Desc. Centro',
                    value: 'desc_centro',
                },
                {
                    text: 'División / Ures',
                    value: 'desc_division',
                },
            ],
            padron: [],
            totalRows: 0,
            search: '',
            electionIdSelected: '',
            isLoading: true,
            options: {
                itemsPerPage: 10,
                sortBy: ['codigo'],
                sortDesc: [false],
            },
        };
    },
    methods: {
        onChangeElection() {
            this.search = '';
            this.loadPadron();
        },
        loadPadron() {
            if (this.electionIdSelected == '') {
                return;
            }
            this.isLoading = true;

            const data = {
                election_id: this.electionIdSelected,
                limit: this.options.itemsPerPage,
                offset: (this.options.page - 1) * this.options.itemsPerPage,
                search: this.search,
            };

            this.$store
                .dispatch('funcionarios/getPadron', data)
                .then(res => {
                    if (res.data) {
                        this.padron = res.data.padron.map(padron => {
                            return padron;
                        });
                        this.totalRows = res.data.total;
                    }
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(_ => {
                    this.isLoading = false;
                });
        },
        textItemElection: item =>
            `${item.id} | ${item.description} | ${item.type.toUpperCase()}`,
    },
    created() {
        this.padron = [];
        this.isLoading = true;
        this.$store.dispatch('elecciones/getElecciones').finally(() => {
            this.isLoading = false;
        });
    },
};
</script>
<style lang="scss">
.lyt-container {
    background-image: url('../assets/bg_udg.png');
    background-color: $votex-background-primary;
}

.table-admins {
    margin-bottom: 100px;

    .datatable-admins {
        width: 100%;
    }
}
</style>
